/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AppointmentActionResponse, MarkNoShowAppointmentsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    markNoShowAppointments: build.mutation<AppointmentActionResponse, MarkNoShowAppointmentsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/appointments/no-show`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as markNoShowAppointmentsApi };
export const { useMarkNoShowAppointmentsMutation } = injectedRtkApi;
